import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { Styles } from '../../../../toolkit/components/';

import { colors, zindex, settings } from '../../styles/theme';

 
const OuterContainer = styled('div')`
  box-shadow: 0 0 10px 0 #bbb;
  border-radius: 3px;
  z-index: ${zindex.modal.below};
  position: absolute;
  top: ${(props) => props.top}px;
  width: 399px;

  @media screen and (min-width: ${settings.mobile.maxWidth}) {
    ${(props) => (props.width ? 'width:' + props.width + 'px;' : '')}
    ${(props) => (props.left ? 'left:' + props.left + 'px;' : '')}
    ${(props) => (props.right ? 'right:' + props.right + 'px;' : '')}
  }

  @media screen and (max-width: ${settings.mobile.maxWidth}) {
    padding-right: 20px;
    padding-left: 20px;
    width: auto;
  }
`;
 

const ContentWrapper = styled('div')`
  @media screen and (min-width: ${settings.mobile.maxWidth}) {
    ::before {
      top: 20px;
      left: -29px;
      border: solid transparent;
      border-right: 3px solid ${(props) => props.commentBtn ? Styles.colors.grey.altDark : Styles.colors.orange.primary};
      border-width: 16px;
      margin-top: -12px;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
    }

    ::after {
      top: 24px;
      left: -20px;
      margin-top: -12px;
      border: solid transparent;
      border-width: 12px;
border-right-color: ${props => props.type === 'commentForm' ? Styles.colors.grey.secondaryLight : Styles.colors.white};
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
    }
  }

  position: relative;
  border-radius: 5px;
  border-left: 0;
  background: #f8f8f8;
  padding: 0px;
`;

export default function FloatingContainer(props) {
  const { children } = props;

  return (
    <OuterContainer {...props}>
      <ContentWrapper {...props}>{children}</ContentWrapper>
    </OuterContainer>
  );
}

FloatingContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
  left: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
  right: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
  borderColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  top: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
};

FloatingContainer.defaultProps = {
  left: null,
  right: null,
  width: null,
  borderColor: colors.orange.primary,
  backgroundColor: colors.white,
};
